import React, { useEffect } from 'react';
import { Spinner } from '@insurancemenu/imenu-components-lib';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'store/rootStore';
import AppRouter from 'routes/AppRouter';
import { SupportedUserRoles } from '@insurancemenu/imenu-components-lib/dist/types/global';
import { zywaveUserRights } from '@insurancemenu/imenu-components-lib/dist/utils/accessRights';
import { Redirect } from 'react-router-dom';
import Cookies from 'js-cookie';
import { SpinnerWrapperStyled, AppWrapperStyled } from './globalStyles';

const BrokerRedirect: React.FC<{ userRoles: SupportedUserRoles[] }> = ({ userRoles }) => {
  if (zywaveUserRights(userRoles)) {
    const groupId = Cookies.get('groupId');
    return <Redirect to={`/zywave-group/${groupId}`} />;
  }

  return <Redirect to="/dashboard" />;
};

/**
 * Broker-side experience: loads domain + agents, then mounts broker routes only.
 */
const BrokerApp: React.FC = observer(() => {
  const {
    agentsStore: { requestAgents, isLoading: agentsLoading },
    domainStoreV2: { loading: domainLoading, getDomainById },
    userStore: { sponsorId },
  } = useRootStore();

  useEffect(() => {
    if (sponsorId) {
      void getDomainById(sponsorId);
    }
  }, [sponsorId]);

  useEffect(() => {
    void requestAgents();
  }, []);

  if (domainLoading || agentsLoading) {
    return (
      <SpinnerWrapperStyled>
        <Spinner />
      </SpinnerWrapperStyled>
    );
  }

  return (
    <AppWrapperStyled>
      <AppRouter RedirectComponent={BrokerRedirect} />
    </AppWrapperStyled>
  );
});

export default BrokerApp;
